import { BasePage } from './BasePage';

export const BaseAuthedPage = BasePage;
